import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";

import i18next from "./i18next";

export function I18nProvider(props) {
    const { language } = props;

    useEffect(
        () => {
            void i18next.changeLanguage(language);
        },
        [language],
    );

    return (
        <I18nextProvider
            { ...props }
            i18n={ i18next }
        />
    );
}
